module.exports = __webpack_public_path__ + "media/images/countryrect/za-da81347a956edb791b8ced540deb5bbb.svg";